import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, Subscription } from 'rxjs';
import { GeofencesService } from 'src/app/features/geofences-map/services/Geofences.service';
import { DataNamesDTO } from 'src/app/features/locations-map/models/DataNamesDTO';
import { LocationCategoryDTO } from 'src/app/features/locations-map/models/LocationCategoryDTO';
import { LocationDTO } from 'src/app/features/locations-map/models/LocationDTO';
import { GeneratedLayerService } from 'src/app/features/locations-map/services/Generated-Layer.service';
import { LocationRelatedService } from 'src/app/features/locations-map/services/LocationRelated.service';
import { LocationsService } from 'src/app/features/locations-map/services/Locations.service';
import { PanelDetailLocationsService } from 'src/app/features/locations-map/services/Panel-Detail-Locations.service';
import { ValetParkingService } from 'src/app/features/locations-map/services/ValetParking.service';
import { TutorialService } from 'src/app/features/shared/features/tutorial/services/tutorial.service';
import { CreateEmptyLocationDTO } from 'src/app/features/shared/helpers/DTO/CreateEmptyLocationDTO';
import { EnumDataLocation_CarKeys } from 'src/app/features/shared/helpers/enums/EnumDataLocation_CarKeys';
import { NameToSingularPipe } from 'src/app/features/shared/pipes/NameToSingular.pipe';
import { MapService } from 'src/app/features/shared/services/Map.service';
import { NotificationsToastService } from 'src/app/features/shared/services/Notifications-Toast.service';
import { SignalUserService } from 'src/app/features/shared/services/ServiceCatalogEncapsulators/Signal-User.service';
import { SessionService } from 'src/app/features/shared/services/Session.service';
import { MapHelperService } from 'src/services/map-helper.service';

@Component({
  selector: 'car-details',
  templateUrl: './car-details.component.html',
  styleUrls: ['./car-details.component.css']
})
export class CarDetailsComponent {

  images: string[] = [];
  isLoadingImages: boolean = false;

  locationDTO: LocationDTO = CreateEmptyLocationDTO();

  Address: string = "";
  Keys: string[] = [];
  KeyNames: DataNamesDTO[] = [];
  Values: string[] = [];
  detallesActivo: string[] = [];
  detallesGPS: string[] = [];
  odometroInicialIndex: number;
  isVisibleDetails: boolean;
  isVisibleBloking: boolean;
  emptyDates: boolean;
  isAdmin: boolean;
  writeOdometer: boolean;
  fullScreen: boolean = false;
  readOdometro: boolean = true;
  isReadAlias: boolean = true;
  isValetParking: boolean = true;
  isValetParkingChecked: boolean = false;
  valetParkingGuid: string;
  lastOdometroGPS: string;
  odometroFinalLocation: number = 0;
  odometroInicialLocationNumero: number;
  lastOdometroGPSNumero: number = 0;
  blokingIcon: string;
  blockingObject: { isVisibleBlocking: boolean, blockingIcon: string};
  Coords: string;
  hasRelatedData: boolean = false;

  locationCategory: LocationCategoryDTO;
  locationCategorySingularName: string;

  private activeIdentifier: string = null;
  private $GeneralData: Observable<any> = new Observable<any>();
  private $Address: Observable<string> = new Observable<string>();
  private $Keys: Observable<string[]> = new Observable<string[]>();
  private $KeyNames: Observable<DataNamesDTO[]> = new Observable<DataNamesDTO[]>();
  private $Coords: Observable<string> = new Observable<string>();
  private $Values: Observable<string[]> = new Observable<string[]>();
  private $ValoresOdometro: Observable<any> = new Observable<any>();
  private $AllowedBloking: Observable<boolean> = new Observable<boolean>();
  private $BlokingIcon: Observable<boolean> = new Observable<boolean>();
  private $Images: Observable<string[]> = new Observable<string[]>();
  public isLoading: boolean = false;
  public $isLoading: Observable<boolean> = new Observable<boolean>();
  $isVisibleDetails: Observable<boolean> = new Observable<boolean>();

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  roles: string;
  isMapix: boolean = false;
  suscription_updateLocationOdometer: Subscription;
  suscription_confirmDialogService: any;
  suscription_createBlokingRequest: Subscription;
  suscription_getDataNames: Subscription;
  suscription_geofenceService: Subscription;
  suscription_getLocationRelatedList: Subscription;
  suscription_getGeneralData: Subscription;
  suscription_coords: Subscription;
  suscription_keys: Subscription;
  suscription_keyNames: Subscription;
  suscription_values: Subscription;
  suscription_getOdometer: Subscription;
  suscription_address: Subscription;
  suscription_getLoading: Subscription;
  suscription_isVisibleDetails: Subscription;
  suscription_getImages: Subscription;

  constructor(
    private sessionService: SessionService,
    private mapService: MapService,
    private signalUserService: SignalUserService,
    private panelDetalilService: PanelDetailLocationsService,
    private locationsService: LocationsService,
    private snackBar: MatSnackBar,
    private notifyToastService: NotificationsToastService,
    private mapHelperService: MapHelperService,
    private valetParkingService: ValetParkingService,
    private geofenceService: GeofencesService,
    private locationRelatedService: LocationRelatedService,
    private generatedLayerService: GeneratedLayerService,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private tutorialService: TutorialService,
    private nameToSingularPipe: NameToSingularPipe
  ) {
    console.log("category existo carro");
    this.mobileQuery = media.matchMedia("(min-width: 760px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.$GeneralData = this.panelDetalilService.getGeneralData();
    this.suscription_getGeneralData = this.$GeneralData.subscribe((element : LocationDTO) => {
      //reseta el componente si se carga otro de la misma categoria
      if (this.activeIdentifier != null && element != null && this.activeIdentifier != element.identifier) {
        this.clearComponent();
      }

      this.locationDTO = element;

      if (this.locationDTO !== null && this.locationDTO.identifier !== null) {
        this.setActiveLayer();
        this.locationCategory = JSON.parse(localStorage.getItem("listaCategorias")).find((item) => item.id == this.locationDTO.idLocationCategory);
        var x = Number(this.locationDTO.cordsX);
        var y = Number(this.locationDTO.cordsY);
        if (typeof y === 'number'  && typeof x === 'number' && !isNaN(y) && !isNaN(x)) {
          this.Coords = y.toFixed(4) + "," + x.toFixed(4);
        }else{
          this.Coords = "No disponible";
        }
        this.locationCategorySingularName = this.nameToSingularPipe.transform(this.locationCategory.shortName);
        this.generatedLayerService.createLayer(this.locationCategorySingularName, this.locationCategorySingularName +" seleccionado", ["location"+this.locationCategory.name+"ActiveSource"], true);
        if (!this.isValetParkingChecked) {
          this.isValetParkingChecked = true;
          this.StopValetParking();
          this.CheckValetParking();
          this.getLocationsRelated();
        }
        this.activeIdentifier = this.locationDTO.identifier;
        this.panelDetalilService.SetOdometerData(this.locationDTO.identifier);
      }
    });
    this.$Coords = this.panelDetalilService.getCoords();
    this.suscription_coords = this.$Coords.subscribe((element) => {
      this.Coords = element;
    });

    this.$Keys = this.panelDetalilService.getKeys();
    this.suscription_keys = this.$Keys.subscribe((element) => {
      this.Keys = [];
      this.Keys = element;

      //Crea arrays de detalles del activo
      this.detallesActivo = this.Keys.filter((item) => !item.includes("GPS"));
      const indiceOdometroInicial = this.detallesActivo.indexOf(
        "Odometro_Inicial"
      );
      if (indiceOdometroInicial !== -1) {
        this.detallesActivo.splice(indiceOdometroInicial, 1);
      }
      this.detallesActivo.sort();
      //Crea arrays de detalles del GPS
      this.detallesGPS = this.Keys.filter((item) => item.includes("GPS"));
      this.detallesGPS.sort();
    });

    this.$KeyNames = this.panelDetalilService.getKeyNames();
    this.suscription_keyNames = this.$KeyNames.subscribe((element) => {
      this.KeyNames = [];
      this.KeyNames = element;
    });
    this.$Values = this.panelDetalilService.getValues();
    this.suscription_values = this.$Values.subscribe((element) => {
      this.Values = [];
      this.Values = element;
    });

    this.$ValoresOdometro = this.panelDetalilService.getOdometer();
    this.suscription_getOdometer = this.$ValoresOdometro.subscribe((element) => {
      this.odometroFinalLocation = element.odometroFinalLocation;
      this.odometroInicialLocationNumero =
        element.odometroInicialLocationNumero;
      this.lastOdometroGPSNumero = element.lastOdometroGPSNumero;
    });

    this.$Address = this.panelDetalilService.getAddress();
    this.suscription_address = this.$Address.subscribe((element) => {
      this.Address = "";
      this.Address = element;
    });
    this.$isVisibleDetails = this.panelDetalilService.checkVisibilityPopup();
    this.suscription_isVisibleDetails = this.$isVisibleDetails.subscribe((element) => {
      this.isVisibleDetails = element;
      setTimeout(() => {
        if (this.isVisibleDetails != undefined && this.isVisibleDetails == true) {
          this.tutorialService.startTutorial(["panelDetailLocationTutorial"]);
        }
      }, 1000);
    });
    this.$Images = this.panelDetalilService.getImages();
    this.suscription_getImages = this.$Images.subscribe((element) => {
      this.images = element;
    });
    this.suscription_getLoading = this.panelDetalilService.getLoading().subscribe((data: boolean) => {
      this.isLoading = data;
    });

    this.InitializePanel();
  }

  ngOnInit(): void {
    this.checkingURL();
  }

  ngOnDestroy() {
    this.clearComponent();
    if (this.suscription_getGeneralData)
      this.suscription_getGeneralData.unsubscribe();
    if (this.suscription_coords)
      this.suscription_coords.unsubscribe();
    if (this.suscription_keys)
      this.suscription_keys.unsubscribe();
    if (this.suscription_keyNames)
      this.suscription_keyNames.unsubscribe();
    if (this.suscription_values)
      this.suscription_values.unsubscribe();
    if (this.suscription_getOdometer)
      this.suscription_getOdometer.unsubscribe();
    if (this.suscription_address)
      this.suscription_address.unsubscribe();
    if (this.suscription_getImages)
      this.suscription_getImages.unsubscribe();
    if (this.suscription_getLoading)
      this.suscription_getLoading.unsubscribe();
  }

  clearComponent(){
    if (this.suscription_updateLocationOdometer)
      this.suscription_updateLocationOdometer.unsubscribe();
    if (this.suscription_confirmDialogService)
      this.suscription_confirmDialogService.unsubscribe();
    if (this.suscription_createBlokingRequest)
      this.suscription_createBlokingRequest.unsubscribe();
    if (this.suscription_geofenceService)
      this.suscription_geofenceService.unsubscribe();
    if (this.suscription_getLocationRelatedList)
      this.suscription_getLocationRelatedList.unsubscribe();

    this.StopValetParking();

    if(this.locationCategorySingularName)
      this.generatedLayerService.deleteLayer(this.locationCategorySingularName, this.locationCategorySingularName +" seleccionado");
    if(this.locationCategory != null){
      this.mapService.UpdateLayerGeoJson("location"+this.locationCategory.name+"ActiveSource",this.mapService.Empty_GeoJson);
      this.mapHelperService.MoveLayer("layer-location"+this.locationCategory.name+"Active", "layer-locationsGeneral");
    }
    if(this.locationDTO != null && this.locationDTO.identifier != null)
      this.signalUserService.UnsubscribeSignalUserIdentifierService(this.locationDTO.identifier);
  }

  InitializePanel() {
    this.blockingObject = { isVisibleBlocking: false, blockingIcon: "lock" };
    // OBSERVABLES PARA BOTON DE BLOQUEO/DESBLOQUEO
    this.$AllowedBloking = this.panelDetalilService.getAllowedBloking();
    this.$AllowedBloking.subscribe((element) => {
      this.isVisibleBloking = element;
      if (this.isVisibleBloking != undefined)
        {
        this.blockingObject.isVisibleBlocking = this.isVisibleBloking;
        if(this.blockingObject.isVisibleBlocking == true) 
          this.locationDTO.canLock ="SI";
        else this.locationDTO.canLock ="NO";
        }
    });
    this.$BlokingIcon = this.panelDetalilService.getBlokingIcon();
    this.$BlokingIcon.subscribe((element) => {
      if (element) {
        this.blokingIcon = "lock";
      } else {
        this.blokingIcon = "lock_open";
      }

      if (this.blokingIcon != undefined)
        this.blockingObject.blockingIcon = this.blokingIcon;
    });
   
  }

  getLocationsRelated(){
    this.suscription_getLocationRelatedList = this.locationRelatedService.GetAllByIdentifier(this.locationDTO.identifier, false).subscribe(data => {
      if (data.isSuccess) {
        if (data.result.listLocationRelated.length > 0)
          this.hasRelatedData = true;
    }
    });
  }

  OpenWarning(message: string) {
    this.snackBar.open(message, "", {
      duration: 3000,
      horizontalPosition: "center",
      verticalPosition: "bottom",
      //panelClass: "alert"
    });
  }

  UpdateInitialOdometer(inputKilometraje) {
    if (
      inputKilometraje.value.length > 0 &&
      inputKilometraje.value > this.lastOdometroGPSNumero
    ) {
      this.isLoading = true;

      this.odometroInicialLocationNumero =
        inputKilometraje.value - this.lastOdometroGPSNumero;

      console.log(
        "odometro input",
        inputKilometraje.value,
        this.odometroInicialLocationNumero,
        this.lastOdometroGPSNumero
      );

      this.suscription_updateLocationOdometer = this.locationsService
        .updateLocationOdometer(
          this.locationDTO.identifier,
          this.odometroInicialLocationNumero
        )
        .subscribe((response) => {
          if (response.isSuccess) {
            this.notifyToastService.showSuccess(
              "Odometro Actualizado",
              "Actualización Exitosa"
            );
            this.odometroInicialLocationNumero = response.result;
            this.odometroFinalLocation =
              parseFloat(this.odometroInicialLocationNumero.toString()) +
              parseFloat(this.lastOdometroGPSNumero.toString());
            console.log(
              "odometro final",
              this.odometroFinalLocation,
              this.odometroInicialLocationNumero,
              this.lastOdometroGPSNumero
            );

            inputKilometraje.value = this.odometroFinalLocation;
          } else {
            this.notifyToastService.showError(
              "El odometro no pudo ser actualizado, contacte al administrador o intentelo nuevamente",
              "Error al actualizar Odometro"
            );
            console.log("Error en la actualización", response);
            inputKilometraje.value = this.odometroFinalLocation;
          }
          this.isLoading = false;
        });
    } else {
      this.notifyToastService.showError(
        "El odometro no pudo ser actualizado, los datos ingresados son menores a los del ultimo GPS",
        "Error al actualizar Odometro"
      );
      inputKilometraje.value = this.removerNoNumero(
        this.odometroFinalLocation.toString()
      );
    }

    this.readOdometro = !this.readOdometro;
  }

  cambiarReadOnlyOdometro(inputKilometraje) {
    if (!this.readOdometro) {
      inputKilometraje.value = this.odometroFinalLocation;
    }
    this.readOdometro = !this.readOdometro;
  }

  removerNoNumero(value: string): string {
    return value.replace(/[^\d.]/g, ""); // Remueve todos los caracteres que no sean números
  }

  validarInputOdometro(inputElement: HTMLInputElement) {
    if ((inputElement.value.match(/\./g) || []).length > 1) {
      console.log(
        "datos invalidos",
        (inputElement.value.match(/\./g) || []).length
      ),
        inputElement.value.endsWith(".");
    } else {
      inputElement.value = inputElement.value.replace(/[^\d.]/g, "");
    }
  }

  getUsableName(keyName: string): string {
    const keyNameObject = this.KeyNames.find((item) => item.keyName == keyName);
    return keyNameObject ? keyNameObject.usableName : keyName;
  }

  //Obtiene la visibilidad según el nombre de la key
  getNameVisibility(keyName) {
    const keyNameObject = this.KeyNames.find(
      (item) => item.keyName === keyName
    );
    return keyNameObject ? keyNameObject.isVisible : true;
  }

  CheckValetParking(){
    if (this.locationDTO.identifier == null || this.locationDTO.identifier == undefined || this.locationDTO.identifier == "") {
      return;
    }

    var valetName = "Valet Parking " + this.locationDTO.identifier;
    this.suscription_geofenceService = this.geofenceService.GetByName(valetName).subscribe((data) => {
      console.log("VALET PARKING", data);
      if(data.isSuccess && data.result != null){
        this.valetParkingService.existValetParking = true;
        this.valetParkingGuid = data.result.guid;
        this.valetParkingService.coordsValetParking = { lat: parseFloat(data.result.geom_CentroidY), lng: parseFloat(data.result.geom_CentroidX) };
        this.valetParkingService.radioKm = parseFloat(data.result.radio);
        this.mapHelperService.UpdateValetParkingBuffer();
      }else{
        if(data.result == "Sequence contains more than one element")
          this.valetParkingService.existValetParking = true;
        else
          this.valetParkingService.existValetParking = false;
      }
    });
  }

  CreateValetParking(){
    this.fullScreen = false;
    this.CheckValetParking();
  }

  //lo manda el botón cuando ha borrado el valet parking
  DeleteValetParking(isDeleted: boolean){
    this.valetParkingService.existValetParking = !isDeleted;
    this.valetParkingGuid = "";
    this.mapHelperService.DeleteValetParkingDragEvent();
    this.mapHelperService.ResetValetOParkingActiveBuffer();
    this.mapHelperService.UpdateLayerGeoJson("centerPointSource", this.mapHelperService.Empty_GeoJson);
    this.valetParkingService.coordsValetParking = { lat: parseFloat(this.locationDTO.cordsY), lng: parseFloat(this.locationDTO.cordsX) };
  }

  StopValetParking(){
    this.mapHelperService.DeleteValetParkingDragEvent();
    this.mapHelperService.ResetValetOParkingActiveBuffer();
    this.mapHelperService.UpdateLayerGeoJson("centerPointSource", this.mapHelperService.Empty_GeoJson);
    this.isValetParking = false;
    this.valetParkingService.closeDialog();
  }

  // onClickItem(e){
  //   this.panelDetalilService.setVisibilityPopup(true);
  //   this.panelDetalilService.setInformation(e.features[0].properties, e.features[0].properties._Id,e.features[0].properties._CreatedIn);

  //         this.panelDetalilService.setData(e.features[0].properties);
  //         this.panelDetalilService.setTitle(e.features[0].properties._Id);
  //         this.panelDetalilService.setLastUpdate(
  //           e.features[0].properties._CreatedIn
  //         );
  // }
  CancelButton() {
    this.panelDetalilService.setVisibilityPopup(false);
    //Remove Client to SignalHub
    this.signalUserService.UnsubscribeSignalUserIdentifierService(this.locationDTO.identifier);
    // this.mapService.ResetCamera();
    this.mapService.UpdateLayerGeoJson(
      "location"+this.locationCategory.name+"ActiveSource",
      this.mapService.Empty_GeoJson
    );
    this.mapHelperService.MoveLayer("layer-location"+this.locationCategory.name+"Active", "layer-locationsGeneral");
    this.odometroFinalLocation = 0;
    this.StopValetParking();
  }

  checkingURL() {
    this.sessionService.CheckURLSource();
    this.isMapix = this.sessionService.isMapix;
  }

  submitAlias(){
    this.isLoading = true;
    this.locationsService.CreateOrUpdateLocationProperty(this.locationDTO.identifier, EnumDataLocation_CarKeys.Alias , this.locationDTO.alias).subscribe((data) => {
      if(data.isSuccess){
        this.notifyToastService.showSuccess("Alias actualizado", "Actualización Exitosa");
      }else{
        this.notifyToastService.showError("El alias no pudo ser actualizado, contacte al administrador o intentelo nuevamente", "Error al actualizar Alias");
        console.log("Error en la actualización", data);
      }
      this.isLoading = false;
      this.isReadAlias = true;
    });
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text);
    this.notifyToastService.showSuccess("Texto copiado al portapapeles", text);
  }

  setActiveLayer() {
    var obj = {
              lat: Number(this.locationDTO.cordsY),
              lng: Number(this.locationDTO.cordsX),
              idntf: this.locationDTO.identifier,
              idLocationCategory: this.locationDTO.idLocationCategory,
              locationCategory: this.locationDTO.locationCategory,
            };
    this.mapHelperService.UpdateActiveLocation(obj);
  }
   
}
